import * as React from "react";
import type { SVGProps } from "react";
const SvgSpadeSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.99 22h-6a1 1 0 0 1-.81-.42 1 1 0 0 1-.14-.9l.71-2.12a4.57 4.57 0 0 1-4.44-1.71 6.54 6.54 0 0 1 .31-8.24C5.18 8 5.77 7.36 6.38 6.78c1.65-1.52 3.29-3 4.94-4.52a1 1 0 0 1 1.34 0l4.92 4.5c.65.62 1.24 1.24 1.78 1.85a6.54 6.54 0 0 1 .31 8.24 4.5 4.5 0 0 1-4.42 1.78l.74 2.05a1 1 0 0 1-.14.9 1 1 0 0 1-.86.42Zm-4.61-2h3.22l-.56-1.68a1.188 1.188 0 0 1-.05-.32v-1a1 1 0 0 1 .55-.9 1 1 0 0 1 1 .1 2.48 2.48 0 0 0 3.49-.55 4.55 4.55 0 0 0-.22-5.72c-.5-.57-1.06-1.14-1.64-1.71l-4.18-3.87-4.24 3.89c-.56.53-1.11 1.11-1.63 1.69a4.55 4.55 0 0 0-.22 5.72 2.6 2.6 0 0 0 3.52.53 1 1 0 0 1 1-.07 1 1 0 0 1 .57.89v1a1.188 1.188 0 0 1-.05.32L10.38 20Z"
    />
  </svg>
);
export default SvgSpadeSymbol;
